import { render, staticRenderFns } from "./StudentTypePanel.vue?vue&type=template&id=3344ff00"
import script from "./StudentTypePanel.vue?vue&type=script&lang=js"
export * from "./StudentTypePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports